import axios from '@/utils/axios.instances'
import Api from '@/api.js'

const axiosInstance = axios.getSTAxios()

// Opens a help-center article in a new tab, signed into Zendesk when possible.
// We exchange our API session for a Zendesk single-sign-on token first; if that
// fails for any reason the article still opens, just without being signed in.
// (A signed-out visitor hitting a restricted article gets Zendesk's own sign-in
// page, which returns to the article after logging in.)
export async function openHelpCenterArticle (articleUrl) {
  // Zendesk rejects sign-on tokens minted by non-production backends, so only
  // production attempts the sign-in (VUE_APP_ZENDESK_SSO); staging and dev
  // open the article directly.
  if (!Api.zendesk_sso) {
    window.open(articleUrl, '_blank')
    return
  }
  try {
    const response = await axiosInstance.get('auth/zendesk/get-token/')
    window.open(`https://scantrust.zendesk.com/access/jwt?jwt=${response.data.token}&return_to=${encodeURIComponent(articleUrl)}`, '_blank')
  } catch (error) {
    window.open(articleUrl, '_blank')
  }
}

// For links that live inside translated HTML (v-html), where Vue click handlers
// can't be attached in the template: finds help-center anchors in the rendered
// content and routes their clicks through openHelpCenterArticle.
// Usage: v-help-center-links on the element carrying v-html.
export const helpCenterLinksDirective = {
  inserted: routeHelpCenterAnchors,
  componentUpdated: routeHelpCenterAnchors
}

function routeHelpCenterAnchors (element) {
  element.querySelectorAll('a[href*="help.scantrust.com"]').forEach((anchor) => {
    if (anchor.dataset.helpCenterRouted) return
    anchor.dataset.helpCenterRouted = 'true'
    anchor.addEventListener('click', (event) => {
      event.preventDefault()
      openHelpCenterArticle(anchor.href)
    })
  })
}
